/**
 * * Text가 버튼( 주로 테이블 안에 쓰인다)
 */
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 * TODO
 * 1. disabled에 따라 not allow 되는 기능 추가
 * 2. disabled일 때, 컬러 변경
 */
interface IProps {
  children: string;
  name?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  onClick?: (e: any) => void;
}
const TextButton = ({ children, style, onClick, name, disabled }: IProps) => {
  return (
    <StyledButton
      name={name}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </StyledButton>
  );
};

export default TextButton;

const StyledButton = styled.button`
  text-align: left;
  width: 100%;
  height: 100%;
  color: ${theme.colors.blueText};
  font-weight: 600;
  &:hover {
    font-weight: 700;
  }
  font-size: ${theme.fontSizes.sm};
`;
